import * as React from 'react';
import { i18n, domain, domainVal } from 'arm-common';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { connect } from 'react-redux';
import * as agui from '../shared/v4';


class TestI18N extends React.Component {
    constructor(props) {
        super(props);

        this.state = { lingua: 'IT' };

        this.componentName = "[TestI18N.jsx] ";
        this.changeLang = this.changeLang.bind(this);
    }


    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        let doms = ["LANG"];
        this.props.loadDomains(doms);
    }


    changeLang(e, index) {
        console.log(this.componentName + 'changeLang [' + e.target.id + '] [' + e.target.value + ']');
        let value = e.target.value;

        this.setState({ lingua: value, });
        this.props.loadI18nLabels(value);
    }



    render() {
        console.log(this.componentName + 'render');

        if (this.props.linguaDomain === undefined) {
            console.log(this.componentName + 'linguaDomain is NULL');
        } else {
            console.log(this.componentName + "instanceof Map " + (this.props.linguaDomain.valori instanceof Object).toString());


            if (this.props.linguaDomain.valori instanceof Object) {

                let keys = Object.getOwnPropertyNames(this.props.linguaDomain.valori);

                for (let key of keys) {
                    //console.log("[" + key + "]");

                    let obj = this.props.linguaDomain.valori[key];

                    console.log("[" + obj.valCampo + "] [" + obj.desDom + "]");
                }

            }
        }

        return (
            <div>

                <h1>Test I18N</h1>






                {/* {(dominioLingua !== undefined && dominioLingua !== null) ?
                    <agui.CoolSelect
                        id="lingua2"
                        disabled={false}
                        required={false}
                        onChange={(val, id) => this.cambiaLingua(val, id)}
                        //value={task.taskType} 
                        value={this.state.lingua}
                        label="LINGUA 2"
                        items={dominioLingua}
                        valueKey="valCampo"
                        labelKey="desDom"
                    //validation={this.props.validationMap}
                    />
                    : null
               */}


                {
                    (this.props.linguaDomain !== undefined && this.props.linguaDomain !== null && this.props.linguaDomain.valori !== {}) ?
                        <agui.ASelectV4
                            id="lingua"
                            disabled={false}
                            required={false}
                            onChange={this.changeLang}
                            value={this.state.lingua}
                            label="Dominio LANG"
                            items={domain("LANG")}
                            valueKey="valCampo"
                            labelKey="desDom"
                        />
                        : null
                }

                <br />



                <table className="table table-responsive table-hover table-striped mt-5">
                    <tbody>
                        <tr>
                            <td>ADV360.YES</td>
                            <td>{i18n('ADV360.YES', 'Valore di default')}</td>
                        </tr>
                        <tr>
                            <td>ADV360.NO</td>
                            <td>{i18n('ADV360.NO', 'Valore di default')}</td>
                        </tr>
                        <tr>
                            <td>BAD.OK</td>
                            <td>{i18n('ARM_CORE_PRODUCT.OK', 'Valore di default')}</td>
                        </tr>
                        <tr>
                            <td>BAD.CANCEL</td>
                            <td>{i18n('ARM_CORE_PRODUCT.CANCEL', 'Valore di default')}</td>
                        </tr>
                        <tr>
                            <td>BAD.YES</td>
                            <td>{i18n('ARM_CORE_PRODUCT.YES', 'Valore di default')}</td>
                        </tr>
                        <tr>
                            <td>BAD.NO</td>
                            <td>{i18n('ARM_CORE_PRODUCT.NO', 'Valore di default')}</td>
                        </tr>

                    </tbody>
                </table>



            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        i18n: state.app.i18nlabels,
        domain: state.app.domini,
        linguaDomain: state.app.domini.LANG,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadI18nLabels(lingua) {
            return dispatch(AppActions.loadI18nLabels(AppConstants.I18N_CODES, lingua));
        },

        loadDomains(doms) {
            return dispatch(AppActions.loadDomains(doms));
        },
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(TestI18N);